// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/models/adminModel';
import model_2 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/models/authModel';
import model_3 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/models/DictModel';
import model_4 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/models/global';
import model_5 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/models/menuModels';
import model_6 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/models/user';
import model_7 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/pages/MainPlatform/models/UserGroupModel';
import model_8 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/pages/CompanyPlatform/DailyManagement/Contract/List/model';
import model_9 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/pages/CompanyPlatform/Employee/List/model';
import model_10 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/pages/CompanyPlatform/Financial/TaxPayment/model';
import model_11 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/pages/MainPlatform/Company/List/model';
import model_12 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/pages/MainPlatform/Permission/Role/model';
import model_13 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/pages/MainPlatform/User/Group/model';
import model_14 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/pages/MainPlatform/User/model';
import model_15 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/pages/ProjectPlatform/RaiseTicket/model';
import model_16 from 'C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'adminModel', model: model_1 },
model_2: { namespace: 'authModel', model: model_2 },
model_3: { namespace: 'DictModel', model: model_3 },
model_4: { namespace: 'global', model: model_4 },
model_5: { namespace: 'menuModels', model: model_5 },
model_6: { namespace: 'user', model: model_6 },
model_7: { namespace: 'MainPlatform.UserGroupModel', model: model_7 },
model_8: { namespace: 'CompanyPlatform.DailyManagement.Contract.List.model', model: model_8 },
model_9: { namespace: 'CompanyPlatform.Employee.List.model', model: model_9 },
model_10: { namespace: 'CompanyPlatform.Financial.TaxPayment.model', model: model_10 },
model_11: { namespace: 'MainPlatform.Company.List.model', model: model_11 },
model_12: { namespace: 'MainPlatform.Permission.Role.model', model: model_12 },
model_13: { namespace: 'MainPlatform.User.Group.model', model: model_13 },
model_14: { namespace: 'MainPlatform.User.model', model: model_14 },
model_15: { namespace: 'ProjectPlatform.RaiseTicket.model', model: model_15 },
model_16: { namespace: '@@initialState', model: model_16 },
} as const
